module.exports = __webpack_public_path__ + "themes/giveandgo/assets/img/5.f216eb25.jpg";